import React, { useEffect, useState } from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

/**
 * A link to Stripe, usually through the backend which first creates the Stripe session. That takes a second or two,
 * so show it's on its way rather than looking like the click didn't register.
 */
export default function StripeButton(props: ButtonProps & { href: string }) {
  const { onClick, children, startIcon, endIcon, sx, ...buttonProps } = props;
  const [opening, setOpening] = useState(false);

  // Coming back with the browser's back button can restore the page as it was left
  useEffect(() => {
    const reset = () => setOpening(false);
    window.addEventListener('pageshow', reset);
    return () => window.removeEventListener('pageshow', reset);
  }, []);

  return (
    <Button
      {...buttonProps}
      startIcon={opening ? <CircularProgress size={16} color="inherit" /> : startIcon}
      endIcon={opening ? undefined : endIcon}
      aria-busy={opening}
      sx={[{ pointerEvents: opening ? 'none' : undefined }, ...(Array.isArray(sx) ? sx : [sx])]}
      onClick={event => {
        setOpening(true);
        onClick?.(event);
      }}
    >
      {opening ? 'Opening Stripe…' : children}
    </Button>
  );
}
